module.exports = __webpack_public_path__ + "img/ihm_icon.3a7f419d.jpg";